import { render, staticRenderFns } from "./TruckView.vue?vue&type=template&id=97943232&"
import script from "./TruckView.vue?vue&type=script&lang=js&"
export * from "./TruckView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports